import { Chip, ChipProps, SxProps, Theme } from '@mui/material';
import React from 'react';

interface Props extends Omit<ChipProps, 'label' | 'color'> {
  onText: React.ReactNode;
  offText?: React.ReactNode;
  status: boolean;
}

function getColorStyles(status: boolean, variant?: ChipProps['variant']): SxProps<Theme> {
  const isOutlined = variant === 'outlined';

  if (isOutlined) {
    return {
      ...(status
        ? {
            // Green outlined badge: #08ecb8 border and text
            borderColor: '#2E7D32',
            color: '#2E7D32',
          }
        : {
            // Pink outlined badge: #ec0864 border and text
            borderColor: '#ec0864',
            color: '#ec0864',
          }),
    };
  }

  return {
    ...(status
      ? {
          // Green badge: #08ecb8 background, #212529 text
          backgroundColor: '#08ecb8',
          color: '#212529',
        }
      : {
          // Pink badge: #ec0864 background, #ffffff text
          backgroundColor: '#ec0864',
          color: '#ffffff',
        }),
  };
}

export const StatusBadge = (props: Props) => {
  const { status, onText, offText, sx, variant, ...rest } = props;

  return (
    <Chip
      label={status ? onText : (offText ?? onText)}
      variant={variant}
      sx={[
        {
          fontWeight: 400,
          textTransform: 'uppercase',
          textAlign: 'center',
        },
        getColorStyles(status, variant),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    />
  );
};
